// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_ud8BU","icon":"index_icon_gOcst"};